export const protocoloCero = [
    {
        'nombreDocumento' : 'Acuerdo que contiene el Protocolo Cero',
        'urlDocumento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/AcuerdoProcotoloCero.pdf',
        'icono' : 'icon-signature'
    },
    {
        'nombreDocumento' : 'Directorio de personas consejeras SIPDUS',
        'urlDocumento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/DirectorioPersonasConsejeras2026.pdf',
        'icono' : 'icon-logbook-2'
    },
    {
        'nombreDocumento' : 'Pronunciamiento de Cero Tolerancia SIPDUS',
        'urlDocumento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/PronunciamientoCeroTolerancia2025.pdf',
        'icono' : 'icon-diffusion',
    }
]